import { SearchFilterAccordionItem } from 'modules/search/components/Filter/AccordionItem/SearchFilterAccordionItem';
import { SearchFilterToggleButton } from 'modules/search/components/Filter/ToggleButton/SearchFilterToggleButton';
import { useSearchFilterSelectedValue } from 'modules/search/hooks/filters/useSearchFilterSelectedValue';
import type { SearchRefinementVariant } from 'modules/search/types/SearchRefinementVariant';

type Props = {
  variant?: SearchRefinementVariant;
};

export function SalaryListedFilter({ variant = 'dropdown' }: Props) {
  const selectedFacetValue = useSearchFilterSelectedValue('hasSalary');

  const FilterVariant =
    variant === 'accordion'
      ? SearchFilterAccordionItem
      : SearchFilterToggleButton;

  return (
    <FilterVariant
      facetType="hasSalary"
      initialValue={selectedFacetValue}
      icon="money"
      label={<>{getText('Salary Listed')} </>}
    />
  );
}
